export default "__VITE_ASSET__JebDBNo$__"